import { TokenRefreshLink } from 'apollo-link-oauth-token-refresh';

import {
  cleanMode,
  getExpirationDate,
  getRefresh,
  setExpirationDate,
  setMode,
  setRefreshToken,
  setToken,
  getMode,
} from '@utils/localStorage';
import { calculateExpirationTime, isExpired } from '@utils/date';
import getRefreshToken from '@services/OAuthServices/getRefreshToken';
import { getLoginUrl } from '@config/getEnviroment';
import loginClient from '@services/OAuthServices/loginClient';

const isValidExpiredToken = () => {
  const expires = getExpirationDate();
  if (!expires || expires.trim() === '') {
    return true;
  }
  return !isExpired(expires);
};
const base = getLoginUrl();

const RefreshLink = new TokenRefreshLink({
  isTokenValidOrUndefined: isValidExpiredToken,
  fetchAccessToken: () => {
    const refreshToken = getRefresh();
    const modeApp = getMode();
    if (!refreshToken || refreshToken.trim() === '' || modeApp === 'client') {
      return loginClient();
    }

    return getRefreshToken({ password: refreshToken });
  },
  handleResponse:
    () =>
    (response: {
      error?: any;
      token_type?: string;
      access_token?: string;
      expires_in: string;
      refresh_token?: string;
    }) => {
      if (response?.error) {
        setToken('');
        setExpirationDate('');
        setRefreshToken('');
        cleanMode();

        if (base) {
          return window.open(`${base}`, '_self');
        }

        return false;
      }
      const { token_type: type, access_token: token, expires_in: expires, refresh_token: refresh } = response;
      if (token) {
        const tokenRefreshed = `${type} ${token}`;
        const expirationDate = calculateExpirationTime(expires);

        setToken(tokenRefreshed);
        setExpirationDate(`${expirationDate}`);

        if (refresh) {
          setRefreshToken(`${refresh}`);
          setMode('user');
        } else {
          setMode('client');
        }

        return true;
      }
      setToken('');
      setExpirationDate('');
      setRefreshToken('');
      return false;
    },
  handleError: () => {
    setToken('');
    setExpirationDate('');
    setRefreshToken('');
    localStorage.clear();

    if (base) {
      window.open(`${base}`, '_self');
    }
  },
});

export default RefreshLink;
